import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyWorkOrdersActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fill: "#0517f8",
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M2 4h5l1 2H2z" }),
			/* @__PURE__ */ _jsx("path", { d: "M16 5.5H9.383L7.25 3.367A1.24 1.24 0 0 0 6.367 3H2.25A1.25 1.25 0 0 0 1 4.25v11.297a1.203 1.203 0 0 0 1.203 1.203h5.719a.625.625 0 0 0 0-1.25H2.25V6.75H16V8a.625.625 0 1 0 1.25 0V6.75A1.25 1.25 0 0 0 16 5.5M6.367 4.25l1.25 1.25H2.25V4.25z" }),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#0517f8",
				strokeWidth: 1.6,
				d: "M2 14.944V6.788h13.44a1 1 0 0 1 1 1v3.578l-7.22 4.578H3a1 1 0 0 1-1-1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#e6e8fe",
				strokeWidth: 1.2,
				d: "m15.759 14.182 1.758-1.453a.633.633 0 0 0-.352-1.11l-2.328-.18-.898-2.07a.626.626 0 0 0-1.141 0l-.898 2.07-2.329.18a.633.633 0 0 0-.351 1.11l1.758 1.453-.531 2.164a.62.62 0 0 0 .234.648.63.63 0 0 0 .687.04l2-1.18 2 1.18a.7.7 0 0 0 .32.085.58.58 0 0 0 .368-.125.62.62 0 0 0 .234-.648z"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h20v20H0z"
		})
	}) })]
});
export default SvgMyWorkOrdersActive;
